'use client'

import React from 'react'

import { MImage } from '../../../../core/MImage'
import { cn } from '../../../../utils/cn'

import type { IHighlight } from '../_types/types'

export interface IDividerImagesAItemProps {
	highlight: IHighlight
	className?: string
}

/**
 * Individual highlight item component.
 * Displays a single highlight with optional title and image.
 */
export const DividerImagesAItem: React.FC<IDividerImagesAItemProps> = ({ highlight, className }) => {
	return (
		<div className={cn('m-divider-images-a__item', className)}>
			<div className='m-divider-images-a__item-top'>
				{highlight.title && <p className='title'>{highlight.title}</p>}
				{highlight.image && (
					<MImage
						src={highlight.image.src}
						alt={highlight.image.alt}
						width={highlight.image.width}
						height={highlight.image.height}
					/>
				)}
			</div>

			<p>{highlight.description}</p>
		</div>
	)
}

DividerImagesAItem.displayName = 'ADividerImagesAItem'
